import React, { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { programmeSelectRedux, partenaireSelectRedux } from '../redux/evenementsServices';
import AccountOnly from './AccountOnly';

// Mount the ordinary page only after its guest-scoped detail data is available.
export default function CompanionRoute({ children }) {
  const params = useParams();
  const session = useSelector(state => state.companion);
  const access = useSelector(state => state.user.access);
  const selected = useSelector(state =>
    params.idprogram ? state.evenements.programmeSelect : state.evenements.exposantSelect
  );
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const isCompanion = Boolean(session.token) && !access;
  const privateProgramme = isCompanion && params.idprogram && params.type !== '0';
  const detailId = params.idprogram || params.id;
  const needsDetail = isCompanion && !privateProgramme && detailId && selected?.id !== detailId;
  useEffect(() => {
    if (!needsDetail) return undefined;
    let active = true;
    setError('');
    const request = params.idprogram
      ? programmeSelectRedux('', detailId)
      : partenaireSelectRedux('', session.event.id, detailId);
    request
      .then(response => {
        if (active)
          dispatch({
            type: params.idprogram
              ? 'evenements/addProgrammeSelect'
              : 'evenements/addExposantSelect',
            payload: response.data,
          });
      })
      .catch(() => {
        if (active) setError('Impossible de charger ces informations.');
      });
    return () => {
      active = false;
    };
  }, [needsDetail, detailId, params.idprogram, session.event?.id, dispatch, retry]);
  if (privateProgramme) return <AccountOnly feature="Ma journée">{children}</AccountOnly>;
  if (isCompanion && params.idevent && params.idevent !== session.event.id) {
    return <Navigate to={`/dashboard/${session.event.id}`} replace />;
  }
  if (needsDetail)
    return (
      <div className="d-flex justify-content-center p-5">
        {error ? (
          <Alert
            severity="error"
            action={<Button onClick={() => setRetry(value => value + 1)}>Réessayer</Button>}
          >
            {error}
          </Alert>
        ) : (
          <CircularProgress aria-label="Chargement" />
        )}
      </div>
    );
  return children;
}
